import type { DirectusFolders } from '@/models/types';
import { Breadcrumbs, Text, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useTranslate } from '@tolgee/react';
import classes from './FileManagerBreadcrumb.module.css';

type Props = {
  currentFolderId: string;
  breadcrumbFolders: DirectusFolders[];
  rootFolderId: string;
  rootLabel: string;
  onNavigateToFolder: (folderId: string) => void;
};

const FileManagerBreadcrumb = ({
  currentFolderId,
  breadcrumbFolders,
  rootFolderId,
  rootLabel,
  onNavigateToFolder,
}: Props) => {
  const { t } = useTranslate();

  const allSegments = [{ id: rootFolderId, name: rootLabel }, ...breadcrumbFolders];

  return (
    <nav aria-label={t('nav.breadcrumb')} className={classes.nav}>
      <Breadcrumbs
        className={classes.breadcrumbs}
        separator={<IconChevronRight size={12} className={classes.separator} />}
      >
        {allSegments.map((segment, index) => {
          const isActive = index === allSegments.length - 1 && segment.id === currentFolderId;

          if (isActive) {
            return (
              <Text key={segment.id} className={classes.activeItem} aria-current="page" size="sm">
                <span className={classes.activeLabel}>{segment.name}</span>
              </Text>
            );
          }

          return (
            <UnstyledButton
              key={segment.id}
              className={classes.itemButton}
              onClick={() => {
                onNavigateToFolder(segment.id);
              }}
            >
              <span className={classes.itemLabel}>{segment.name}</span>
            </UnstyledButton>
          );
        })}
      </Breadcrumbs>
    </nav>
  );
};

export default FileManagerBreadcrumb;
